'use strict';

const notifications = require('../components/notifications');

const selectors = {
    alertContainer: '.js-alert-wrapper',
    submitButton: '.js-contact-us-submit',
    contactForm: '.js-contact-us',
    captchaError: '.js-recaptcha-error',
    reCaptchaField: '.js-gCaptchaToken-contactus'
};

/**
 * Make submit button reusable
 * @param {Object} button - button that was clicked for contact us sign-up
 */
function enableSubmitButton(button) {
    setTimeout(function () {
        button.removeAttr('disabled');
    }, 3000);
};

/**
 * Submits contact us form
 * @param {obj} form Contac us form data
 */
function submitContactUsForm(form) {
    var url = form.attr('action');
    var button = $(selectors.submitButton);
    button.attr('disabled', true);
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: function (data) {
            if (data.success) {
                var email = form.find('input[type=email]').val();

                $(selectors.contactForm).trigger('reset');
                notifications.create(data.msg, 'success');

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'contact.form',
                    form_type: email
                });

            } else {
                notifications.create(data.msg, 'error');
            }
            form.find(selectors.reCaptchaField).val('');
            enableSubmitButton(button);
            $.spinner().stop();

        },
        error: function (err) {
            notifications.create(err, 'error');
            form.find(selectors.reCaptchaField).val('');
            enableSubmitButton(button);
            $.spinner().stop();
        }
    });
}

module.exports = {
    subscribeContact: function () {
        $(selectors.contactForm).on('submit', function (e) {
            e.preventDefault();
            var form = $(this);
            $.spinner().start();
            // Verify if Google reCaptcha is enabled/loaded
            if (window.grecaptcha) {
                // Google reCaptcha Site key
                var gsiteKey = form.data('gsite-key');
                window.grecaptcha.ready(function () {
                    window.grecaptcha
                        .execute(gsiteKey, {action: form.data('action')})
                        .then(function (token) {
                            form.find(selectors.reCaptchaField).val(token);
                            submitContactUsForm(form);
                        });
                });
            } else {
                submitContactUsForm(form);
            }
            $.spinner().stop();
        });
    }
};
